export const enum WeatherActionTypes {
    GET_CURRENT_WEATHER_DATA = 'GET_CURRENT_WEATHER_DATA',
    GET_WEATHER_FORECAST_DATA = 'GET_WEATHER_FORECAST_DATA',
}
